export const sampleDigests = [
  {
    id: 9,
    interval: { start: "Jan 27", end: "Feb 02" },
    full_interval:
      "00:00 UTC, Monday, January 27, 2020 - 23:59 UTC, Sunday, February 02, 2020",
  },
  {
    id: 8,
    interval: { start: "Jan 20", end: "Jan 26" },
    full_interval:
      "00:00 UTC, Monday, January 20, 2020 - 23:59 UTC, Sunday, January 26, 2020",
  },
  {
    id: 7,
    interval: { start: "Jan 13", end: "Jan 19" },
    full_interval:
      "00:00 UTC, Monday, January 13, 2020 - 23:59 UTC, Sunday, January 19, 2020",
  },
  {
    id: 6,
    interval: { start: "Jan 06", end: "Jan 12" },
    full_interval:
      "00:00 UTC, Monday, January 06, 2020 - 23:59 UTC, Sunday, January 12, 2020",
  },
  {
    id: 5,
    interval: { start: "Dec 30", end: "Jan 05" },
    full_interval:
      "00:00 UTC, Monday, December 30, 2019 - 23:59 UTC, Sunday, January 05, 2020",
  },
  {
    id: 4,
    interval: { start: "Dec 23", end: "Dec 29" },
    full_interval:
      "00:00 UTC, Monday, December 23, 2019 - 23:59 UTC, Sunday, December 29, 2019",
  },
  {
    id: 3,
    interval: { start: "Dec 16", end: "Dec 22" },
    full_interval:
      "00:00 UTC, Monday, December 16, 2019 - 23:59 UTC, Sunday, December 22, 2019",
  },
  {
    id: 2,
    interval: { start: "Dec 09", end: "Dec 15" },
    full_interval:
      "00:00 UTC, Monday, December 09, 2019 - 23:59 UTC, Sunday, December 15, 2019",
  },
  {
    id: 1,
    interval: { start: "Dec 02", end: "Dec 08" },
    full_interval:
      "00:00 UTC, Monday, December 02, 2019 - 23:59 UTC, Sunday, December 08, 2019",
  },
];
